import { AffiliateUser, NumericProject } from 'types/user';
import createRootSelector from 'common/apps/core/selectors/createRootSelector';

import { AuthPartialState } from '../reducers/auth';

const currentProjectIdSelector = createRootSelector(
  (state: AuthPartialState<AffiliateUser>) => state,
  (state) => state.auth?.user?.project.id || NumericProject.Stripchat,
);

export default currentProjectIdSelector;
